export default __webpack_public_path__ + "static/media/WordWork_16.186c73c9.png";